import { createAsyncAction, createAction } from 'redux-promise-middleware-actions';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import api from '../api/apiSettings';

export const types = {
  ...addAsyncActionPostfixes({
    GET_ALL_JOB_ALERTS: 'GET_ALL_JOB_ALERTS',
    CREATE_NEW_JOB_ALERT: 'CREATE_NEW_JOB_ALERT',
    EDIT_JOB_ALERT: 'EDIT_JOB_ALERT',
    DELETE_JOB_ALERT: 'DELETE_JOB_ALERT',
    SHOW_ALL: 'SHOW_ALL',
    UNSUBSCRIBE_JOB_ALERT: 'UNSUBSCRIBE_JOB_ALERT',
    REVERT_DELETED_ALERT: 'REVERT_DELETED_ALERT',
    CARD_STYLE: 'CARD_STYLE'
  })
};

export const getAllJobAlerts = createAsyncAction(types.GET_ALL_JOB_ALERTS, () =>
  api.get(`v1/job/alert`).then((res) => res.data)
);

export const createNewJobAlert = createAsyncAction(types.CREATE_NEW_JOB_ALERT, (data) =>
  api.post(`v1/job/alert`, data).then((res) => ({ ...res.data.Data }))
);

export const editJobAlert = createAsyncAction(types.EDIT_JOB_ALERT, (data) =>
  api.put(`v1/job/update-alert/${data.Id}`, data).then((res) => ({ ...res.data.Data }))
);

export const deleteJobAlert = createAsyncAction(types.DELETE_JOB_ALERT, (id) =>
  api.delete(`v1/job/alert?jobAlertId=${id}`).then(() => id)
);

export const revertDeletedJobAlert = createAsyncAction(types.REVERT_DELETED_ALERT, (alert) =>
  api.put(`v1/job/undelete-alert?jobAlertId=${alert.Id}`).then(() => alert)
);

export const updateSlicedAlert = createAction(types.SHOW_ALL, (payload) => payload);
export const unsubscribeJobAlert = createAsyncAction(types.UNSUBSCRIBE_JOB_ALERT, (isActive) =>
  api.put(`/v1/job/unsubscribe-alert?isActive=${isActive}`).then((res) => res.data)
);

export const updateCardStyle = createAction(types.CARD_STYLE, (payload) => payload);
